import React, { useRef, useCallback } from 'react'
import { Button, Select } from 'antd'
import * as Icons from '@ant-design/icons'

import { useGlobalShortcut } from 'admin/lib/shortcuts'
import { Matchers } from 'admin/lib/Records'
import { FormRow, FormItem } from 'admin/lib/Forms'
import { Queries } from 'admin/lib/Api'
import { calculateAssignmentOptions } from 'admin/lib/assigneeFunctions'
import { RAW } from './constants'

export function FormControls({ dataView }) {
  const { hiddenElement } = useSaveShortcut()
  const users = Queries.useQflowUsers()

  const isRawDataView = dataView === RAW

  return (
    <>
      <FormRow>
        <FormItem label="Status" name="status">
          <Select>
            <Select.Option
              aria-label="Published"
              title={'Published (Must be in Enhanced View to select)'}
              value="Published"
              disabled={isRawDataView}
            >
              Published
            </Select.Option>
            <Select.Option aria-label="Escalated" value="Escalated">
              Escalated
            </Select.Option>
            <Select.Option aria-label="Failed" value="Failed">
              Failed
            </Select.Option>
            <Select.Option aria-label="Void" value="Void">
              Void
            </Select.Option>
            <Select.Option aria-label="Removed" value="Removed" disabled>
              Removed
            </Select.Option>
            <Select.Option aria-label="New" value="New" disabled>
              New
            </Select.Option>
          </Select>
        </FormItem>

        {hiddenElement}

        <Button
          type="primary"
          style={{ width: '37.5%' }}
          htmlType="submit"
          icon={<Icons.UploadOutlined />}
        >
          Save {dataView}
        </Button>
      </FormRow>

      {users.data && (
        <FormRow style={{ width: '100%' }}>
          <FormItem label="Assignee" name="assignee">
            <Select showSearch={true}>
              {calculateAssignmentOptions(users.data)}
            </Select>
          </FormItem>
        </FormRow>
      )}
    </>
  )
}

function useSaveShortcut() {
  const submitButtonRef = useRef()

  useGlobalShortcut(
    Matchers.form.save,
    useCallback(() => {
      document.activeElement.blur()
      submitButtonRef.current.click()
    }, [])
  )

  return {
    hiddenElement: <input type="submit" hidden ref={submitButtonRef} />
  }
}
